import * as XLSX from 'xlsx';
import Url from '../global/Url';
import { getCsrf } from './auth';

// Columnas esperadas por tipo (coinciden con la tabla destino, en minúsculas).
export const COLUMNAS = {
    pre:  ['telefono', 'id_servicio', 'monto', 'identificacion', 'nombre'],
    post: ['telefono', 'id_servicio', 'fecha_alta', 'descripcion_plan', 'identificacion',
           'tipo_id', 'nombre_completo', 'ciudad', 'tb', 'permin'],
};

const FILAS_POR_LOTE = 2000;

/** Lee Excel/CSV y devuelve { headers (minúsculas), filas (objetos) }. */
export function leerArchivo(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (evt) => {
            try {
                const wb = XLSX.read(evt.target.result, { type: 'binary' });
                const ws = wb.Sheets[wb.SheetNames[0]];
                const matriz = XLSX.utils.sheet_to_json(ws, { header: 1, raw: false, defval: '' });
                if (matriz.length === 0) { reject(new Error('El archivo está vacío')); return; }
                const headers = matriz[0].map((h) => String(h).trim().toLowerCase());
                const filas = [];
                for (let i = 1; i < matriz.length; i++) {
                    const fila = matriz[i];
                    if (!fila || fila.every((c) => String(c).trim() === '')) continue;
                    const obj = {};
                    headers.forEach((h, j) => { obj[h] = String(fila[j] ?? '').trim(); });
                    filas.push(obj);
                }
                resolve({ headers, filas });
            } catch (e) {
                reject(new Error('No se pudo leer el archivo: ' + e.message));
            }
        };
        reader.onerror = () => reject(new Error('Error al leer el archivo'));
        reader.readAsBinaryString(file);
    });
}

export function validarColumnas(headers, tipo) {
    const esperadas = COLUMNAS[tipo];
    for (const c of esperadas) {
        if (!headers.includes(c)) {
            return `Falta la columna "${c}". El archivo ${tipo.toUpperCase()} debe tener: ${esperadas.join(', ')}.`;
        }
    }
    return null;
}

/** Valida una fila: el teléfono debe ser 09XXXXXXXX. Devuelve motivo o null. */
export function validarFila(f) {
    const tel = String(f.telefono ?? '').replace(/\D/g, '');
    if (tel === '') return 'Teléfono vacío';
    if (!/^09[0-9]{8}$/.test(tel)) return 'Teléfono debe ser 09XXXXXXXX';
    return null;
}

export function contarInvalidos(filas) {
    let n = 0;
    for (const f of filas) if (validarFila(f) !== null) n++;
    return n;
}

export function descargarFallos(fallos, tipo) {
    const cols = COLUMNAS[tipo];
    const matriz = [[...cols, 'MOTIVO']];
    for (const { fila, motivo } of fallos) matriz.push([...cols.map((c) => fila[c] ?? ''), motivo]);
    const ws = XLSX.utils.aoa_to_sheet(matriz);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Fallos');
    const stamp = new Date().toISOString().slice(0, 19).replace(/[:T]/g, '-');
    XLSX.writeFile(wb, `fallos-${tipo}-${stamp}.xlsx`);
}

export async function subir(filas, tipo, onProgreso) {
    const cols = COLUMNAS[tipo];
    const validas = [], fallos = [];
    for (const f of filas) {
        const motivo = validarFila(f);
        if (motivo) fallos.push({ fila: f, motivo });
        else validas.push(f);
    }
    const total = { insertadas: 0, actualizadas: 0, invalidas: fallos.length, procesadas: 0, totalFilas: filas.length, fallos };

    let primero = true;
    for (let inicio = 0; inicio < validas.length; inicio += FILAS_POR_LOTE) {
        const lote = validas.slice(inicio, inicio + FILAS_POR_LOTE).map((f) => {
            const o = {}; cols.forEach((c) => { o[c] = f[c] ?? ''; }); return o;
        });
        const resp = await fetch(Url.Api + 'cargaConsulta', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-CSRF': getCsrf() || '' },
            body: JSON.stringify({ tipo, primero, rows: lote }),
        });
        const data = await resp.json();
        if (!resp.ok || data.header !== 'OK') throw new Error(data.message || 'Error del servidor en un lote');
        total.insertadas += data.insertadas;
        total.actualizadas += data.actualizadas;
        total.procesadas += lote.length;
        primero = false;
        if (onProgreso) onProgreso({ ...total, procesadas: total.procesadas + fallos.length });
    }
    total.procesadas = total.totalFilas;
    if (onProgreso) onProgreso({ ...total });
    return total;
}
